/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ShopBreadcrumbs_landingPage$ref = any;
export type ShopBreadcrumbs_landingPage = {
    readonly title: string | null;
    readonly " $refType": ShopBreadcrumbs_landingPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShopBreadcrumbs_landingPage",
  "type": "LandingPage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '737f14e41dae051207ffadd92a2fda81';
export default node;
